import COLORS from "./colors";

/** Readable disabled state for primary/gradient buttons on light surfaces. */
export const disabledContainedButtonSx = {
  color: `${COLORS.surface.primaryText} !important`,
  WebkitTextFillColor: `${COLORS.surface.primaryText} !important`,
  backgroundImage: "none !important",
  backgroundColor: `${COLORS.surface.track} !important`,
  border: `1px solid ${COLORS.surface.border}`,
  opacity: 1,
  filter: "none",
  boxShadow: "none",
  "& .MuiCircularProgress-root": {
    color: `${COLORS.surface.secondaryText} !important`
  }
};

/** Shared primary CTA styles (enabled + disabled). */
export const primaryContainedButtonSx = {
  color: COLORS.white,
  backgroundImage: `linear-gradient(135deg, ${COLORS.gradients.button.left}, ${COLORS.gradients.button.right})`,
  boxShadow: "none",
  "&:hover": {
    backgroundImage: `linear-gradient(135deg, ${COLORS.gradients.button.left}, ${COLORS.gradients.button.right})`,
    filter: "brightness(1.05)",
    boxShadow: "none"
  },
  "&.Mui-disabled": disabledContainedButtonSx,
  "& .MuiCircularProgress-root": { color: COLORS.white }
};
